<template>
  <AuthLayout title="HRDOS | Reset Password">
    <div
      style="
        min-height: 100vh;
        display: flex;
        align-items: center;
        justify-content: center;
      "
    >
      <div
        class="container blue lighten-5 z-depth-3"
        style="max-width: 420px; padding: 50px; border-radius: 32px"
      >
        <div class="center-align" style="margin-bottom: 40px">
          <div
            class="white circle z-depth-2 valign-wrapper center"
            style="
              width: 120px;
              height: 120px;
              justify-content: center;
              margin: 0 auto;
            "
          >
            <img src="@/assets/LTOlogo.png" style="width: 85%; height: auto" />
          </div>
          <h5 class="blue-text text-darken-4 bold">LTO HR-DOS</h5>
          <p>RESET PASSWORD</p>
        </div>

        <div v-if="successMessage" class="center-align">
           <i class="material-icons green-text" style="font-size: 4rem;">check_circle</i>
           <h6 class="green-text bold" style="margin-top: 10px;">{{ successMessage }}</h6>
           
           <div style="margin-top: 30px; width: 100%">
             <router-link to="/" class="btn waves-light indigo darken-3 bold" style="width: 100%; border-radius: 8px;">
               Return to Login
             </router-link>
           </div>
        </div>

        <form v-else @submit.prevent="submitNewPassword()">
          
          <div class="input-field">
            <input
              class="validate"
              :class="{ 'invalid': error }"
              id="new_password"
              :type="isNewPasswordVisible ? 'text' : 'password'"
              v-model="form.password"
              required
              minlength="8"
            />
            <label for="new_password">New Password (Min 8 chars)</label>
            <i 
              class="material-icons password-toggle" 
              @click="isNewPasswordVisible = !isNewPasswordVisible" 
              style="position: absolute; right: 3px; bottom: 33px; cursor: pointer; z-index: 2;"
            >
              {{ isNewPasswordVisible ? 'visibility_off' : 'visibility' }}
            </i>
          </div>

          <div class="input-field">
            <input
              class="validate"
              :class="{ 'invalid': error }"
              id="confirm_password"
              :type="isConfirmPasswordVisible ? 'text' : 'password'"
              v-model="form.password_confirmation"
              required
              minlength="8"
            />
            <label for="confirm_password">Confirm New Password</label>
            <i 
              class="material-icons password-toggle" 
              @click="isConfirmPasswordVisible = !isConfirmPasswordVisible" 
              style="position: absolute; right: 3px; bottom: 33px; cursor: pointer; z-index: 2;"
            >
              {{ isConfirmPasswordVisible ? 'visibility_off' : 'visibility' }}
            </i>
          </div>

          <div>
            <p class="red-text" style="text-align: fixed; margin-top: -15px !important;">{{ error }}</p>
          </div>

          <div style="margin-top: 50px; width: 100%">
            <button
              class="btn waves-light indigo darken-3 bold"
              type="submit"
              :disabled="loading || !form.token || !form.email"
              style="width: 100%; display: flex; justify-content: center; align-items: center;"
            >
              <span v-if="loading">Resetting...</span>
              <span v-else>Reset Password</span>
              <i v-if="!loading" class="material-icons" style="margin-left: 8px">lock_reset</i>
            </button>
          </div>
          
          <div style="text-align: center; margin-top: 20px; margin-bottom: 10px;">
            <router-link to="/" class="blue-text" style="font-size: 0.9rem;">Back to Login</router-link>
          </div>
        </form>
      </div>
    </div>
  </AuthLayout>
</template>

<script>
import api from "../axios";
import AuthLayout from "./layout/AuthLayout.vue";

export default {
  name: "ResetPasswordView",
  components: {
    AuthLayout,
  },
  data() {
    return {
      form: {
        token: "",
        email: "",
        password: "",
        password_confirmation: "",
      },
      error: "",
      successMessage: "",
      loading: false,
      isNewPasswordVisible: false,
      isConfirmPasswordVisible: false,
    };
  },
  mounted() {
    // Extract the secure token and email from the URL when they click the email link
    const params = new URLSearchParams(window.location.search);
    this.form.token = params.get('token');
    this.form.email = params.get('email');

    if (!this.form.token || !this.form.email) {
      this.error = "Invalid or missing password reset link.";
    }
  },
  methods: {
    submitNewPassword() {
      this.error = "";
      this.successMessage = "";

      if (this.form.password !== this.form.password_confirmation) {
        this.error = "Passwords do not match.";
        return;
      }

      this.loading = true;

      api.post("/reset-password", this.form)
        .then(() => {
          this.successMessage = "Password successfully reset!";
          this.form.password = "";
          this.form.password_confirmation = "";
          
          // Auto redirect to login after 3 seconds
          setTimeout(() => {
            this.$router.push("/");
          }, 3000);
        })
        .catch((err) => {
          if (err.response && err.response.data && err.response.data.errors) {
            const errors = err.response.data.errors;
            this.error = errors.password ? errors.password[0] : "Validation error.";
          } else if (err.response && err.response.data && err.response.data.message) {
            this.error = err.response.data.message;
          } else {
            this.error = "An error occurred while resetting the password.";
          }
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>

<style scoped>
.password-toggle:hover {
  color: #1565c0;
}
</style>